// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"239dc750","55":"658bb631","188":"9ec05cfd","239":"ce722ccf","241":"fc75a519","270":"6699dd2f","357":"bcbc9dc5","453":"f31200d3","506":"6f5c2d02","618":"bb7ecb3b","622":"a9ef9a3e","641":"862b01d0","820":"a76492d3"}[chunkId] + ".chunk.js";
};